import {
  Stack,
  ActionIcon,
  Text,
  Group,
  Table,
  Divider,
  FlexProps,
  StackProps,
} from "@mantine/core"
import { ReactNode } from "react"
import { FieldData } from "../../../-components/field-data"
import { ScrollContainer } from "../../../-components/scroll-container"
import { useBreakpoints } from "../../../utils/use-breakpoints"
import { FieldDataType } from "../../../@client/Theasoft_DataClasses"

export interface DetailCardAction {
  onClick: () => void
  disabled?: boolean
  children: JSX.Element
}

interface DetailsCardProps {
  children: ReactNode | ReactNode[]
  title?: ReactNode
  actions?: DetailCardAction[]
  buttons?: ReactNode[] | React.ReactNode
  scrollContainerProps?: FlexProps
  stackProps?: StackProps
}

export function DetailsCard({
  children,
  title,
  actions,
  buttons,
  scrollContainerProps,
  stackProps,
}: DetailsCardProps) {
  const { active } = useBreakpoints()

  let mah = undefined

  switch (active) {
    case "xs":
    case "sm":
    case "md":
    case "lg":
    case "none":
      break
    case "xl":
    case "xxl":
    case "xxxl":
      mah = "100%"
  }
  return (
    <Stack
      mah={mah}
      gap={"xs"}
      style={{ breakInside: "avoid", minWidth: 0, overflow: "hidden" }}
      p="sm"
      h="min-content"
      w={"100%"}
      {...stackProps}
    >
      <Group gap={"xs"} justify="space-between">
        {typeof title === "string" ? <Text fw={500}>{title}</Text> : title}
        <Group style={{ alignSelf: "start" }}>
          {buttons}
          {actions?.map((v, i) => (
            <ActionIcon key={i} {...v} />
          ))}
        </Group>
      </Group>
      <Divider />
      <ScrollContainer px="xs" {...scrollContainerProps}>
        {children}
      </ScrollContainer>
    </Stack>
  )
}
interface RowProps {
  label: string
  value: string
  dataType: FieldDataType
}

export function TableDetailsCard(props: {
  rows: RowProps[]
  title: ReactNode
  actions?: DetailCardAction[]
  buttons?: ReactNode[] | React.ReactNode
}) {
  const { rows } = props
  return (
    <DetailsCard {...props}>
      <Table>
        <Table.Tbody>
          {rows.map((row, index) => (
            <Row key={"details-card-row" + index} {...row} />
          ))}
        </Table.Tbody>
      </Table>
    </DetailsCard>
  )
}

export function Row(props: RowProps) {
  const { value, label, dataType } = props
  return (
    value && (
      <Table.Tr>
        {label && <Table.Td>{label}</Table.Td>}
        <Table.Td colSpan={label ? 1 : 2} style={{ lineClamp: 4 }}>
          {
            <FieldData
              fieldData={{
                textValue: value,
                dataType: dataType,
              }}
            />
          }
        </Table.Td>
      </Table.Tr>
    )
  )
}
